import URI from "urijs";

const SOURCE_WIDGET = "WIDGET";

export default class WidgetHelper {
  constructor() {
    const url = window.location.href;

    this.uri = new URI(url);
    this.query = this.uri.query(true);
  }

  isWidget(appSettings) {
    return appSettings.source && appSettings.source === SOURCE_WIDGET;
  }

  broadcastDimensions(templateId) {
    window.parent.window.postMessage(
      JSON.stringify({
        frameId: this.query.frameId,
        height: document.body.offsetHeight,
        templateId
      }),
      "*"
    );
  }
}
